/* eslint-disable max-len */
import { } from 'types';
import * as yup from 'yup';
import { v4 as uuidv4 } from 'uuid';

import { recipeFirstKey } from './constant';

export const makeInstructionsInitData = () => {
  const initialMultipleInstructions = {
    id: uuidv4(),
    titleAm: null,
    titleEn: null,
    titleRu: null,
    descriptionAm: null,
    descriptionEn: null,
    descriptionRu: null,
    images: [],
    existingImages: [],
    uploadedFiles: null
  }

  return initialMultipleInstructions
}

export const initialFormState = {
  titleAm: '',
  titleEn: '',
  titleRu: '',
  descriptionAm: null,
  descriptionEn: null,
  descriptionRu: null,
  ingredientsAm: null,
  ingredientsEn: null,
  ingredientsRu: null,
  images: [],
  existingImages: [],
  uploadedFiles: null,
  minRead: 1,
  minMake: 1,
  postedDate: new Date(),
  visible: true,
  new: true,
  popular: true,
  activeInHome: false,
  productsList: [],
  [recipeFirstKey]: [],
}

const imageListSchemaOptional = yup.mixed()
  .test(
    'is-files-length',
    'You can upload maximum 5 file',
    (value) => Object.keys(value || {}).length <= 5
  )
  .nullable()

const instructions = yup.array()
  .of(yup.object({
    titleAm: yup.string().optional().max(250, 'Title must contain at least maximum length 250').nullable(),
    titleEn: yup.string().optional().max(250, 'Title must contain at least maximum length 250').nullable(),
    titleRu: yup.string().optional().max(250, 'Title must contain at least maximum length 250').nullable(),
    descriptionAm: yup.string().optional().max(10000, 'Description must contain at least maximum length 10000').nullable(),
    descriptionEn: yup.string().optional().max(10000, 'Description must contain at least maximum length 10000').nullable(),
    descriptionRu: yup.string().optional().max(10000, 'Description must contain at least maximum length 10000').nullable(),
  }))

export const createRecipeSchema = yup.object().shape({
  titleAm: yup.string().required('Title is required.').max(250, 'Title must contain at least maximum length 250'),
  titleEn: yup.string().required('Title is required.').max(250, 'Title must contain at least maximum length 250'),
  titleRu: yup.string().required('Title is required.').max(250, 'Title must contain at least maximum length 250'),
  descriptionAm: yup.string().optional().max(10000, 'Description must contain at least maximum length 10000').nullable(),
  descriptionEn: yup.string().optional().max(10000, 'Description must contain at least maximum length 10000').nullable(),
  descriptionRu: yup.string().optional().max(10000, 'Description must contain at least maximum length 10000').nullable(),
  ingredientsAm: yup.string().optional().max(10000, 'Ingredients must contain at least maximum length 10000').nullable(),
  ingredientsEn: yup.string().optional().max(10000, 'Ingredients must contain at least maximum length 10000').nullable(),
  ingredientsRu: yup.string().optional().max(10000, 'Ingredients must contain at least maximum length 10000').nullable(),
  visible: yup.boolean().required(),
  activeInHome: yup.boolean().required(),
  new: yup.boolean().required(),
  popular: yup.boolean().required(),
  minRead: yup.number().required(),
  minMake: yup.number().required(),
  postedDate: yup.string().required(),
  productsList: yup.array().of(yup.string().optional()),
  instructions,
});
